import { render } from "./index.vue?vue&type=template&id=af1c4524"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/news-and-seminars/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af1c4524"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af1c4524', __exports__)) {
    api.reload('af1c4524', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=af1c4524", () => {
    api.rerender('af1c4524', render)
  })

}


export default __exports__